import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import React from "react";
import { Divider } from "@mui/material";
import { cacheUtils } from "../../../../../../../../..";
import { CacheTypes } from "@utils/cache/interfaces";
import queueMap from "../helpers";

const name = "JobDetailsFailed";

interface JobDetailsFailedProps {
    call: any
}

const JobDetailsFailed: React.FC<JobDetailsFailedProps> = ({ call }) => {
    return (
        <Stack >
            <Typography sx={{ margin: 0 }}>{`Date: ${new Date(call.dte_start || 0).toLocaleDateString("en-GB")} ${new Date(call.dte_start || 0).toLocaleTimeString("en-GB")}`}</Typography>
            <Typography sx={{ margin: 0 }}>{`Queue: ${queueMap.get(call.queue_key)}`}</Typography>
            <Typography sx={{ margin: 0 }}>{`Dest: ${call.destination}`}</Typography>
            <Typography sx={{ margin: 0 }}>{`Account: ${call.accountCode}`}</Typography>
            <Typography sx={{ margin: 0 }}>{`Answered by: ${cacheUtils.getCache<CacheTypes.Agents>("Agents").find(a => a.agent_id === call.agent_id)?.full_name}`}</Typography>
            <Divider />
        </Stack>
    )
}

JobDetailsFailed.displayName = name;

export default React.memo(JobDetailsFailed);